import { Box, Flex } from 'grid-styled'
import * as React from 'react'
import Layout from '../components/Layout'
import { Helmet } from 'react-helmet'

import CTA from '../components/CTA'
import Header from '../components/Header'
import FAQs from '../components/FAQs'

import { faqsInfo as socialFaqs } from './services/social-media-marketing'

import { faqsInfo as seoFaqs } from './services/search-engine-optimisation'

import { faqsInfo as adFaqs } from './services/google-ppc-advertising'

import { faqsInfo as webFaqs } from './services/website-development-brisbane'

import { faqsInfo as contactFaqs } from './contact'

const faqsInfo = [
  ...socialFaqs,
  ...seoFaqs,
  ...adFaqs,
  ...webFaqs,
  ...contactFaqs
]

export default () => (
  <Layout>
    <Helmet>
      <title>Frequently Asked Questions - FAQs - Turboclicks</title>
      <meta
        name="description"
        content="Still have questions? We've got the answers, have a read through some common questions and if that doesn't do it, chat with us directly."
      />
    </Helmet>
    <Header>
      <h1>Frequently asked questions</h1>
    </Header>
    <FAQs data={faqsInfo} />
    <CTA
      title="Having an issue?"
      subtitle="We’re here to help you."
      button="Contact Us"
    />
  </Layout>
)
